<template>
  <div>
    <OverlayLoading :loading="loading" />
    <div>
      <v-data-table
        :headers="headers"
        :items="roleCompanyData"
        class="border-table-employee text-no-wrap mt-1"
        item-key="_id"
        :expanded.sync="expanded"
        :loading="loading"
        loading-text="Loading... Please wait"
        :footer-props="{
          'items-per-page-options': [15, 30, 50, 100, -1],
          'items-per-page': 15
        }"
        :server-items-length="total || -1"
        @update:items-per-page="changePerPage"
        @update:page="changePage"
        disable-sort
        :page.sync="page"
        :items-per-page="perPage"
        hide-default-footer
        @page-count="pageCount = $event"
      >
        <template v-slot:[`item.name`]="{ item }">
          <span>{{ item.name }}</span>
        </template>
                    <template v-slot:[`item.status`]="{ item }">
              <v-chip
                :color="['approve','acknowledge', 'active'].includes(item.status)? '#ECF8EA': ['reject', 'expire'].includes(item.status)? '#FBE5E4': ['pending'].includes(item.status)? '#FEF5E9': ['cancel'].includes(item.status)? '#F5F5F5':'#ECF9FF'"
                :text-color="statusList.filter(e => e.status === item.status)[0].color"
              >
                <span>{{ statusList.filter(e => e.status === item.status)[0].statusTH || '' }}</span>
              </v-chip>
            </template>
            <template v-slot:[`item.tag`]="{ item }">
              <div v-for="(items, i) in item.tag" :key="i">
                <v-chip
                v-show="items.name"
                class="mb-2"
                :color="['approve','acknowledge'].includes('cancel')? '#ECF8EA': ['reject'].includes('cancel')? '#FBE5E4': ['pending'].includes('cancel')? '#FEF5E9': ['cancel'].includes('cancel')? '#F5F5F5':'#ECF9FF'"
                :text-color="statusList.filter(e => e.status === 'cancel')[0].color"
              >
                <span>{{items.name}}</span>
              </v-chip>
              </div>
            </template>
      </v-data-table>
      <v-row>
        <v-col cols="12" class="pa-0">
        <div class="justify-end d-flex align-end pt-4">
          <v-pagination
            v-model="page"
            :length="pageCount"
            :total-visible="5"
          ></v-pagination>
        </div>
        </v-col>
      </v-row>
    </div>
    <div class="text-center">
      <v-row>
        <v-snackbar
          v-model="snackbar"
          :timeout="timeout"
          :color="snackbarColor"
          text
          top
          app
        >
        <v-icon left dark small :color="snackbarColor">fa-check-circle</v-icon>
        <span :style="{ 'color': `${snackbarColor}` }">{{ text }}</span>
        </v-snackbar>
      </v-row>
    </div>
  </div>
</template>

<script>
import {
  getSelectRoleReceive,
  fetchAllRoleReceive
} from '@/API/API'
// import { OverlayLoading } from '@/components/index'
import OverlayLoading from '../../_template/OverlayLoading.vue'

import { EventBus } from '@/EventBus'
// import swal from 'sweetalert'
const moment = require('moment')
// const axios = require('axios')

export default {
  components: {
    OverlayLoading
  },
  data () {
    return {
      snackbar: false,
      timeout: 2000,
      snackbarColor: '',
      text: '',
      dialogConfirm: false,
      dialogApproverCompany: false,
      dialogConfirmDel: false,
      approveType: '',
      comment: '',
      delConfirmId: '',
      expanded: [],
      filter: '',
      keywordShortName: '',
      keywordCompanyName: [],
      keywordGroupCompanyName: [],
      loading: true,
      perPage: 15,
      page: 1,
      pageCount: 0,
      total: -1,
      canSave: false,
      statusList: [
        { status: 'pending', statusTH: 'รออนุมัติ', color: '#E9A016' },
        { status: 'approve', statusTH: 'อนุมัติแล้ว', color: '#58A144' },
        { status: 'reject', statusTH: 'ไม่อนุมัติ', color: '#D1392B' },
        { status: 'cancel', statusTH: 'ยกเลิก', color: '#757575' },
        { status: 'acknowledge', statusTH: 'รับทราบแล้ว', color: '#58A144' },
        { status: 'active', statusTH: 'โอนสิทธิ์แล้ว', color: '#58A144' },
        { status: 'expire', statusTH: 'หมดอายุ', color: '#D1392B' },
        { status: 'inActive', statusTH: 'ยกเลิก', color: '#757575' }
      ],
      headers: [
        {
          text: 'ลำดับ',
          align: 'center',
          value: 'no',
          width: '65',
          sortable: false
        },
        { text: 'สิทธิ์ที่ได้รับ', value: 'name' },
        { text: 'รูปแบบการอนุมัติ', value: 'conditions' },
        { text: 'ชื่อคนโอน', value: 'nameTh' },
        { text: 'ตำแหน่ง', value: 'positionName' },
        { text: 'ระดับตำแหน่ง', value: 'positionLv' },
        { text: 'วันที่โอน', value: 'startDate' },
        { text: 'ระยะเวลา', value: 'period' },
        { text: 'สถานะ', value: 'status' },
        { text: 'Tag', value: 'tag' }
        // { text: 'จัดการ', value: 'data-table-expand', sortable: false, width: '130px', align: 'center fixed', class: 'column-fix' }
      ],
      mockup: [],
      selectData: [],
      roleCompanyData: [],
      approveRole: localStorage.approveRole
    }
  },
  async created () {
    this.url = process.env.VUE_APP_API_URL
    this.port = process.env.VUE_APP_API_PORT
    this.api = this.url + ':' + this.port
    this.tokenUser = this.$store.state.token
    try {
      await this.initData()
    } catch (error) {
    } finally {
      // this.loading = false
    }
  },
  mounted () {
    EventBus.$on('roleReceiveSearch', this.getSelect)
  },
  methods: {
    onImgError (i) {
      this.roleCompanyData[i].failed_image = true
    },
    changePerPage (value) {
      this.perPage = value
      this.initDataTable()
    },
    changePage (value) {
      this.page = value
      this.initDataTable()
    },
    async getSelect (data) {
      // console.log('filter search', data)
      this.filter = data
      this.keywordCompanyName = data.companyName
      this.keywordGroupCompanyName = data.groupCompany
      await this.initData()
    },
    initData () {
      this.initSelectData()
      this.initDataTable()
    },
    async initSelectData () {
      this.loading = true
      this.selectData = []
      const token = this.tokenUser
      try {
        const res = await getSelectRoleReceive(token)
        // console.log('🚀 ~ initSelectData ~ res', res)
        if (res.success) {
          // if (res.compermission.length) {
          this.selectData = res
          EventBus.$emit('getFilterฺRoleReceive', this.selectData)
          EventBus.$emit('selectGroup', res)
          // }
          // console.log(res)
        } else {
          // console.log(res)
        }
      } catch (error) {
        // alert(error)
        console.log(error)
      } finally {
        this.loading = false
      }
    },
    async initDataTable () {
      this.loading = true
      this.roleCompanyData = []
      const self = this
      const temp = []
      var obj = {
        search: this.filter.search || '',
        authenId: this.filter.authenId || [],
        status: this.filter.status || [],
        limit: this.perPage,
        page: this.page
      }
      const token = this.tokenUser

      try {
        const res = await fetchAllRoleReceive(obj, token)
        // console.log('🚀  ~ res authen receive', res)
        if (res.success) {
          res.result.map((el, index) => {
            el.conditions = el.conditions === 'all' ? 'อนุมัติทั้งหมด' : 'อนุมัติคนใดคนหนึ่ง'
            el.startDate = this.initDate(el.startDate)
            el.endDate = this.initDate(el.endtDate)
            temp.push({
              no: index + 1,
              failed_image: false,
              period: el.startDate + ' - ' + el.endDate,
              ...el
            })
          })
          this.total = res?.count || -1
          self.roleCompanyData = temp
        } else {
          // console.log(res)
        }
      } catch (error) {
        // alert(error)
        console.log(error)
      } finally {
        this.loading = false
      }
    },
    initDate (date) {
      return moment(date).format('DD/MM/YYYY')
    },
    manageLineWork (data) {
      // console.log('manage line work', data)
    },
    openDialogManage (item) {
      EventBus.$emit('opendialogmanage', true, item)
    },
    openDialogRoleList (item) {
      // console.log('Open', item)
      EventBus.$emit('opendialogRoleListGroup', item)
    },
    gotocreate (title) {
    },
    gotoEdit (data, title) {
      this.$router.push('managetransferrole/updateBusiness/' + data._id)
    }
  }
}
</script>
<style>
.border-table-employee {
  border-radius: 10px;
  border: 1px solid rgb(229, 236, 238);
}

table > tbody > tr > td.fixed:nth-last-child(1),
table > thead > tr > th.fixed:nth-last-child(1) {
  position: sticky !important;
  position: -webkit-sticky !important;
  right: 0;
  /* z-index: 9997; */
  background: white;
  /* background: transparent; */
  -webkit-box-shadow: -1px 0px 3px -1px rgba(0, 0, 0, 0.19);
  -moz-box-shadow: -1px 0px 3px -1px rgba(0, 0, 0, 0.19);
  box-shadow: -1px 0px 3px -1px rgba(0, 0, 0, 0.19);
}

table > tbody > tr:hover > td.fixed:nth-last-child(1), table > thead > tr:hover > th.fixed:nth-last-child(1) {
  background: #eeeeee;
}

table > thead > tr > th.fixed:nth-last-child(1) {
  /* z-index: 9998; */
  background-color: #F8F9FB;
}

</style>
<style>
/* table */
.theme--light.v-pagination .v-pagination__item--active {
    background: #2BA197 !important;
    color: #FFFFFF;
}
.v-pagination__item {
    background: transparent;
    border-radius: 4px;
    font-size: 14px;
    height: 30px;
    margin: 0.3rem;
    min-width: 30px;
    padding: 0 5px;
    text-decoration: none;
    transition: 0.3s cubic-bezier(0, 0, 0.2, 1);
    width: auto;
    box-shadow: 0px 0px 1px 0px rgba(0, 0, 0, 0.2), 0px 0px 0px 0px rgba(0, 0, 0, 0.14), 0px 1px 3px 0px rgba(0, 0, 0, 0.12);
}
.v-pagination__navigation {
    box-shadow: 0px 0px 1px 0px rgba(0, 0, 0, 0.2), 0px 0px 0px 0px rgba(0, 0, 0, 0.14), 0px 1px 3px 0px rgba(0, 0, 0, 0.12);
    border-radius: 4px;
    display: inline-flex;
    justify-content: center;
    align-items: center;
    text-decoration: none;
    height: 30px;
    width: 30px;
    margin: 0.3rem 10px;
}
/* end */
.v-data-table {
  font-family: 'Sarabun', sans-serif;
  font-weight: normal;
  font-size: 16px;
}
.row-menu-left {
  justify-content: flex-start !important;
}
.row-menu-right {
  justify-content: flex-end !important;
}
.v-data-table tbody tr.v-data-table__expanded__content {
  box-shadow: inset 0px 4px 8px -5px rgba(50, 50, 50, 0), inset 0px -4px 8px -5px rgba(50, 50, 50, 0) !important;
}
.padding-left-90 {
  padding-left: 90px !important;
}
.table-name-row {
  display: flex;
  flex-direction: row;
}
.btn-edit-dep {
  background-color: #0370B7 !important;
  color: #fff !important;
}
.btn-del-dep {
  background-color: #da2525 !important;
  color: #fff !important;
}
</style>
